function SeoInsights() {
  return (
    <section id="seo-insights" className="bg-white py-24 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">

        {/* Left Content */}
        <div>
          <h2 className="text-4xl font-extrabold text-black mb-6">
            Leading Wiper Manufacturer & Cleaning Solutions Provider in India
          </h2>

          <p className="text-gray-700 leading-relaxed mb-6">
            <strong>BNM Wipers</strong> is a trusted{" "}
            <span className="font-semibold">
              wiper manufacturer in India
            </span>{" "}
            specializing in high-quality{" "}
            <span className="font-semibold">
              floor cleaning wipers, industrial wipers, glass wipers, and custom-size cleaning tools
            </span>.
            Our{" "}
            <span className="font-semibold">
              manufacturing unit in Ghaziabad, Delhi NCR
            </span>{" "}
            serves wholesalers, retailers, and bulk buyers across multiple states and neighbouring countries.
          </p>

          <h3 className="text-2xl font-bold text-black mb-4">
            Why Businesses Choose Our Industrial Wipers
          </h3>

          <ul className="space-y-3 text-gray-700 mb-8">
            <li>✔ Bulk supply of <strong>heavy-duty floor wipers for commercial cleaning</strong></li>
            <li>✔ Custom manufacturing for <strong>local market and export requirements</strong></li>
            <li>✔ Reliable <strong>wiper supplier in UP, Delhi NCR & North India</strong></li>
            <li>✔ Quality-checked products from <strong>ISO-style production standards</strong></li>
            <li>✔ Fast dispatch for <strong>wholesale cleaning tools and accessories</strong></li>
          </ul>

          <h3 className="text-2xl font-bold text-black mb-4">
            Serving Retailers, Distributors & Bulk Buyers
          </h3>

          <p className="text-gray-700 leading-relaxed">
            We supply <strong>cleaning wipers for shops, hotels, hospitals, warehouses, factories, and automotive service centers</strong>.
            Our reputation as a{" "}
            <strong>
              trusted wholesale wiper manufacturer near Delhi NCR
            </strong>{" "}
            is built on consistent quality, competitive pricing, and long-term business relationships.
          </p>
        </div>

        {/* Right Highlight Box */}
        <div className="bg-gray-100 rounded-3xl p-10 shadow-xl border border-gray-200">
          <h3 className="text-3xl font-extrabold text-blue-700 mb-6">
            Bulk Orders & Custom Manufacturing
          </h3>

          <ul className="space-y-4 text-gray-700 mb-8">
            <li>✔ Private Label & Branding Support</li>
            <li>✔ Dealer & Distributor Pricing</li>
            <li>✔ Custom Sizes & Packaging</li>
            <li>✔ Export-Ready Documentation</li>
          </ul>

          <a
            href="https://wa.me/919891451698?text=Hello!%20I%20want%20to%20enquire%20about%20bulk%20wiper%20manufacturing%20and%20custom%20orders."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block w-full bg-blue-700 hover:bg-blue-800 text-white font-bold px-8 py-4 rounded-full text-center transition-all duration-300 hover:scale-105"
          >
            Request Bulk Quote on WhatsApp <i className="fa-brands fa-whatsapp"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default SeoInsights;